import React, { useState } from 'react';
import TierHeader from './TierHeader';
import TierLegends from './TierLegends';
import { Collapse } from 'reactstrap';
import TierNode from './TierNode';
import { Framework, Tier5 } from 'src/shared/types/src';

const TierFive  = ({ _framework, expand }: { _framework: Framework, expand: boolean }) => {
  const [isVisible, setIsVisible] = useState(expand);
  const assessments = _framework.assessments as Tier5;
  // Remove the mock data after integration
  
  return (
    <div className='framework-tier-wrap'>
      <TierHeader tierTitle={_framework.name} onClick={() => setIsVisible(!isVisible)} isVisible={isVisible} />
        <Collapse isOpen={isVisible}> 
          <div className='mg-t-10'>
            <TierLegends assessmentLevels={_framework.assessmentLevel} />
            <div className='mg-t-5'>
              { assessments?.levels?.map((levels, index) => 
                <TierNode content={levels.name} key={index} borderColor={levels.color} customLabelStyle={'fw-semibold'}>
                  { levels?.areas?.map((areas, index) => 
                    <TierNode content={areas.name} key={index} borderColor={areas.color} customLabelStyle={'fw-semibold'} customContainerStyle={`${areas.color ? 'mg-t-10' : (index === 1 ? 'mg-t-10' : 'mg-t-0')}`}>
                      {
                        areas?.aspects?.map((aspect, idx) => 
                          <TierNode content={aspect.name} key={index} borderColor={aspect.color} customLabelStyle={'fw-semibold'} customContainerStyle={`${aspect.color ? 'mg-t-10' : (idx === 1 ? 'mg-t-10' : 'mg-t-0')}`}>
                            {aspect.age_bands.map((ageBand, i) => 
                                <TierNode content={ageBand.name} borderColor={ageBand.color} key={`${index}-${idx}-${i}`} customLabelStyle={'fw-semibold'}>
                                  {
                                    ageBand.statements.map((statement, j) => 
                                      <TierNode content={statement.name} label={statement.label} iconType={statement.iconType} borderColor={statement.color} key={`${index}-${idx}-${i}-${j}`} isStatement={true} />
                                    )
                                  }
                                </TierNode>
                              )
                            }
                          </TierNode>
                        )
                      }
                    </TierNode>
                  )}
                </TierNode>
              )}
            </div>
          </div>
        </Collapse>
    </div>
  );
};

export default TierFive;
